/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderMarketPositioningMapViewReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StakeholderMarketPositioningMapViewReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderMarketPositioningMapViewTemplate = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderMarketPositioningMapViewReport);
  }
}(this, function(ApiClient, StakeholderMarketPositioningMapViewReport) {
  'use strict';




  /**
   * The StakeholderMarketPositioningMapViewTemplate model module.
   * @module model/StakeholderMarketPositioningMapViewTemplate
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StakeholderMarketPositioningMapViewTemplate</code>.
   * @alias module:model/StakeholderMarketPositioningMapViewTemplate
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>StakeholderMarketPositioningMapViewTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StakeholderMarketPositioningMapViewTemplate} obj Optional instance to populate.
   * @return {module:model/StakeholderMarketPositioningMapViewTemplate} The populated <code>StakeholderMarketPositioningMapViewTemplate</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ThumbnailURL')) {
        obj['ThumbnailURL'] = ApiClient.convertToType(data['ThumbnailURL'], 'String');
      }
      if (data.hasOwnProperty('ScreenshotURL')) {
        obj['ScreenshotURL'] = ApiClient.convertToType(data['ScreenshotURL'], 'String');
      }
      if (data.hasOwnProperty('View')) {
        obj['View'] = StakeholderMarketPositioningMapViewReport.constructFromObject(data['View']);
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} ThumbnailURL
   * @default ''
   */
  exports.prototype['ThumbnailURL'] = '';
  /**
   * @member {String} ScreenshotURL
   * @default ''
   */
  exports.prototype['ScreenshotURL'] = '';
  /**
   * @member {module:model/StakeholderMarketPositioningMapViewReport} View
   */
  exports.prototype['View'] = undefined;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


